module.exports = __webpack_public_path__ + "static/media/news-placeholder.d1223c1e.png";